import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  rootHeader: {},
  rootResults: {},
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
}));

export default useStyles;
